'use client';

import { SetupMockResolver } from '@dva/frameio-uxp-messaging';
import { ClientRenderBoundary } from '@frameio/shared/components/ClientRenderBoundary';

/**
 * This component is used to instantiate a GraphQL resolver that returns mock data for the UXP Messaging for E2E testing.
 * It is only used in development mode.
 * @returns
 */
export const MockResolver = () => {
  return (
    <ClientRenderBoundary>
      <SetupMockResolver />
    </ClientRenderBoundary>
  );
};
